import { setUserItem } from '@/shared/util/userLocalStorage';
import { EXPAND_OPENSHIFT_ROW } from '@/store/action-types';

export function expandOpenShiftRow() {
  setUserItem('openShiftRowCollapsed', false);
  return {
    type: EXPAND_OPENSHIFT_ROW,
  };
}
